import {ArticulosFrontend} from "services-comun-meteored/modules/services/redaccion/articulos/articulos-frontend";
import {TDevice} from "services-comun/modules/net/device";
import type {DominioTiempo} from "services-comun-meteored/modules/portal/tiempo";

import {ESelector} from "../data/auxiliares";
import {NoticiaPlantilla} from "../tmpl";
import builder, {type NewsBuilder} from "../data/builders/news";
import {ControladorRedaccionUltimas, type IControladorRedaccionUltimas} from "./index";

export class ControladorRedaccionUltimaNews extends ControladorRedaccionUltimas {
    /* INSTANCE */
    protected builder: NewsBuilder;

    public constructor(ctx: IControladorRedaccionUltimas) {
        super(ctx);

        this.builder = builder((dominio: DominioTiempo, idioma: string, tipo: number)=>ArticulosFrontend.searchLastWebV4(dominio, idioma, tipo));
    }

    protected async getPlantilla(): Promise<NoticiaPlantilla> {
        const subdir = this.ctx.selector==ESelector.NOTICIAS_DESARROLLO ? "common" : "news";
        const device = this.ctx.cfg.device==TDevice.mobile ? "mv" : "pc";

        let plantilla: string;
        switch(this.ctx.selector) {
            case ESelector.NOTICIAS_DESARROLLO:
                this.limite = 5;
                plantilla = "article";
                break;
            case ESelector.NOTICIAS_DIRECTORIO:
                plantilla = "directory";
                break;
            case ESelector.NOTICIAS_HOME:
                plantilla = "home";
                break;
            case ESelector.NOTICIAS_LOCALIDAD:
                plantilla = "locality";
                break;
            default:
                throw new Error(`Selector desconocido: ${this.ctx.selector}`);
        }

        return import(/* webpackChunkName: "module/redaccion/last/tmpl/[request]" */ (`../tmpl/${subdir}/${plantilla}-${device}`)).then(modulo=>modulo.default);
    }
}
